/* eslint formatjs/no-literal-string-in-jsx: "error" */
import { FlexContainer, Image } from "@carrotfertility/carotene"
import React from "react"
import { useIntl } from "react-intl"

export const TalkToCarrotMultilingualImage = (): JSX.Element => {
  const intl = useIntl()
  const imageAltText = intl.formatMessage({
    defaultMessage: "language-selection"
  })
  return (
    <FlexContainer
      width="100%"
      maxHeight="336px"
      background="lightBlue"
      borderRadius="8px"
      justifyContent="center"
      alignItems="center"
      paddingTopBottom="10%"
      sx={{ marginBottom: "16px" }}
    >
      <Image
        src={require(`./resources/illo-benefit-chat-language-selection.png`)}
        srcSet={require(`./resources/illo-benefit-chat-language-selection-2x.png`)}
        altText={imageAltText}
        width="52%"
        height="74%"
        sx={{ maxWidth: "312px", maxHeight: "250px" }}
      />
    </FlexContainer>
  )
}
